/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum MaklervertragBefristung {
    Unbefristet = 'Unbefristet',
    Befristet = 'Befristet'
  }

    export const MaklervertragBefristungTranslocoMap: Record<MaklervertragBefristung, string> = {
    [MaklervertragBefristung.Unbefristet]: 'maklervertragBefristung.unbefristet',
    [MaklervertragBefristung.Befristet]: 'maklervertragBefristung.befristet',
    };

    export const MaklervertragBefristungOptions = [
  { value: MaklervertragBefristung.Unbefristet, labelKey: 'maklervertragBefristung.unbefristet' },
  { value: MaklervertragBefristung.Befristet, labelKey: 'maklervertragBefristung.befristet' },
    ];

